import { render } from "./svg-other.vue?vue&type=template&id=e0f75ed2"
import script from "./svg-other.vue?vue&type=script&lang=ts"
export * from "./svg-other.vue?vue&type=script&lang=ts"
script.render = render

export default script